// extracted by mini-css-extract-plugin
export default {"editInvoice":"EditInvoice_editInvoice__gmNYx"};